import { defineStore } from 'pinia';
import api from '@/api';

let inFlightFetch = null;

/**
 * The current user's effective permission keys (their role's permissions
 * unioned with any direct extra grants). Fetched once per session - both
 * auth.js's syncProfile() and router/index.js's beforeEach call fetch(),
 * so the router guard can await it (guaranteeing MainLayout never mounts
 * before permissions are known - otherwise every v-permission-gated
 * element would flash-hide, since the directive only checks once at mount)
 * while syncProfile's own call is a no-op if the router already triggered it.
 */
export const usePermissionsStore = defineStore('permissions', {
  state: () => ({
    keys: [],
    loaded: false
  }),

  getters: {
    can: (state) => (permissionKey) => !permissionKey || state.keys.includes(permissionKey),
    hasAny: (state) => (permissionKeys) => permissionKeys.some((key) => state.keys.includes(key))
  },

  actions: {
    async fetch() {
      if (this.loaded) return;
      if (inFlightFetch) return inFlightFetch;

      inFlightFetch = (async () => {
        try {
          const response = await api.user.getMyPermissions();
          this.keys = response.data || [];
          this.loaded = true;
        } catch (e) {
          console.error('Failed to fetch permissions:', e);
        } finally {
          inFlightFetch = null;
        }
      })();

      return inFlightFetch;
    },

    clear() {
      this.keys = [];
      this.loaded = false;
      inFlightFetch = null;
    }
  }
});
